export default "/img/CI.5e85f2164a1815f9212efa6f0944206c.png";